module.exports = __webpack_public_path__ + "media/cubes.34bc7c28.webm";